import {Module} from '@mamdev/cad.static-next-lib';
import Tracking2 from '../../ts/services/tracking2';

export default class Breadcrumb extends Module {
  constructor(root: HTMLElement) {
    super(root);

    this.name_ = 'breadcrumb';
  }

  static attachTo(root: HTMLElement): Breadcrumb {
    return new Breadcrumb(root);
  }

  start() {
    Tracking2.bindTrackingClickHandler(this.root_.querySelectorAll('[data-component-path]'));
  }
}
